import ChartPanel from '/components/statistics/chart-panel'
import FilterBar from '/components/statistics/filter-bar'
import PageShell from '/components/statistics/page-shell'
import useClientStatistics from '/components/statistics/use-client-statistics'

const compactChartSetting = {
  yAxis: [{ label: 'count', width: 90 }]
}

const StatisticsScans = () => {
  const { loading, periodDays, setPeriodDays, selectableTemplates, statistics, templateId, setTemplateId } = useClientStatistics()

  return (
    <PageShell title="Statistics Scans" heading="Statistics - Scans">
      <div className='flex flex-col gap-5 mt-5 pb-20'>
        <FilterBar
          periodDays={periodDays}
          setPeriodDays={setPeriodDays}
          templateId={templateId}
          setTemplateId={setTemplateId}
          selectableTemplates={selectableTemplates}
          summaryItems={[
            { title: 'Scans', value: statistics.extraTotals.scans }
          ]}
        />

        <ChartPanel
          title='Scan trends'
          description='Shows scan activity recorded through daily scan reporting.'
          dataset={statistics.scanTrend}
          xAxis={{ scaleType: 'band', dataKey: 'bucket_label' }}
          series={[{ dataKey: 'scans', label: 'Scans' }]}
          loading={loading}
          height={380}
          yAxis={compactChartSetting.yAxis}
        />
      </div>
    </PageShell>
  )
}

export default StatisticsScans
